import React from 'react';

import { VideoDownloadProvider as BaseVideoDownloadProvider } from '@lyearn/lygo-core';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';

import useVideoDownload from './hooks/useVideoDownload';

const VideoDownloadProvider: React.FC<React.PropsWithChildren> = (props) => {
  const { children } = props;
  const { onVideoDownload } = useVideoDownload();
  const { [FeatureFlags.EnableDownloadVideo]: enableDownloadVideo } = useFeatureFlags();

  return (
    <BaseVideoDownloadProvider
      enableDownloadVideo={enableDownloadVideo}
      onDownload={onVideoDownload}>
      {children}
    </BaseVideoDownloadProvider>
  );
};

export default VideoDownloadProvider;
